<template>
 <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader"/>
      <rule-game :title="ruleTitle.payRate" :value="rulePayrate"/>
      <rule-game :title="ruleTitle.rule" :value="ruleGame"/>
      <rule-game :title="ruleTitle.score" :value="ruleScore"/>
    </div>
  </div>
</template>

<script>
// import Board from '../../assets/gamerule/pokdeng/PD-Board.png';
import Pd1 from '../../assets/gamerule/pokdeng2/PD_1.png';
import Pd2 from '../../assets/gamerule/pokdeng2/PD_2.png';
import Pd3 from '../../assets/gamerule/pokdeng2/PD_3.png';
import Pd4 from '../../assets/gamerule/pokdeng2/PD_4.png';
import Pd5 from '../../assets/gamerule/pokdeng2/PD_5.png';
import Pd6 from '../../assets/gamerule/pokdeng2/PD_6.png';
import Pd7 from '../../assets/gamerule/pokdeng2/PD_7.png';

export default {
  name: 'rule_pokdeng2',
  data() {
    return {

      ruleHeader: {
        gameName: 'ป๊อกเด้ง (Pokdeng) 2',
        boardImg: '',
      },
      ruleTitle: {
        payRate: 'อัตราการจ่าย',
        rule: 'กติกา',
        score: 'แต้มไพ่',
      },
      rulePayrate: [
        {
          type: 'text',
          text: 'อัตราจ่าย 1 : 0.97',
        },
        {
          type: 'text',
          text: 'หากผู้เล่นลงเดิมพัน 100 บาท และได้รับชัยชนะ ผู้เล่นจะได้รับเงินจากการเดิมพัน 97 บาท',
        },
      ],
      ruleGame: [
        {
          type: 'text',
          text: 'ในส่วนของผลตอบแทนเรียงตามอัตราการจ่ายของเจ้า',
        },
        {
          type: 'textSub',
          text: 'ตอง อัตราจ่าย 5 เท่า , เรียงฟรัช อัตราจ่าย 5 เท่า , เรียง อัตราจ่าย 3 เท่า , เซียน อัตราจ่าย 3 เท่า , 3 เด้ง อัตราจ่าย 3 เท่า , 2 เด้ง อัตราจ่าย 2 เท่า , ป๊อก 8 - 9 อัตราจ่าย 1 เท่า , ชนะเจ้ากินตามอัตราของแต่ละคน',
          class: 'ml-3',
        },
        {
          type: 'text',
          text: 'ลำดับการเอาชนะของไพ่และผลตอบแทน',
          class: 'mt-2',
        },
        {
          type: 'textSub',
          text: 'สำหรับลำดับการชนะจะเรียงดังต่อไปนี้ ป๊อก 9 (ป๊อกเก้า 2 เด้ง) > ป๊อก 8 (ป๊อกแปด 2 เด้ง) > ตอง > เรียงฟรัช > เรียง > เซียน > แต้มปกติ',
          class: 'ml-3',
        },
        {
          type: 'textSubcolor',
          textSubcolor: '** ถ้าหากได้แต้มน้อยกว่า 4 แต้ม 2 เด้ง ระบบจะทำการจั่วไพ่ให้โดยอัติโนมัติ**',
          class1: 'ml-3',
        },
      ],
      ruleScore: [
        {
          type: 'text',
          text: 'ป๊อก 8 - ป๊อก 9',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: Pd1,
          class: 'w-50',
          text: 'ไพ่ 2 ใบ รวมกันได้ 8 แต้มหรือ 9 แต้ม',
        },
        {
          type: 'text',
          text: 'ตอง',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: Pd2,
          class: 'w-50',
          text: 'ไพ่ 3 ใบ เลขหรือตัวเดียวกัน',
        },
        {
          type: 'text',
          text: 'เรียงฟลัช',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: Pd3,
          class: 'w-50',
          text: 'ไพ่ 3 ใบ เรียงกันดอกเดียวกัน',
        },
        {
          type: 'text',
          text: 'เรียง',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: Pd4,
          class: 'w-50',
          text: 'ไพ่ 3 ใบ เรียงกันแต่คนละดอก',
        },
        {
          type: 'text',
          text: 'เซียน',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: Pd5,
          class: 'w-50',
          text: 'ไพ่ 3 ใบ ในกลุ่ม J,Q,K ไม่เรียงกัน',
        },
        {
          type: 'text',
          text: '2-3 เด้ง',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: Pd6,
          class: 'w-50',
          text: 'ดอกไพ่ หรือเลขตัวเดียวกัน 2-3 ใบ',
        },
        {
          type: 'text',
          text: 'แต้มปกติ',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: Pd7,
          class: 'w-50',
          text: 'แต้มปกติ 0-9แต้ม',
        },
      ],
    };
  },
};
</script>

<style scoped>
.tonhg{
    font-size: 1.1vw;
    padding: 0 4rem;
    color: green;
}
</style>
